<button type="button" [disabled]="disabled" pButton [icon]="icon" [label]="label" [class.p-button-outlined]="variant === 'outlined'"></button>
